import React from 'react';
import { Flex, TooltipMenu, Icon } from '@haldor/ui';
import DateTime from '_class/DateTime';

var Message = function Message(props) {
  var className = 'conversation message';
  var timestampClass = 'timestamp';

  if (props.me) {
    className += ' me';
    timestampClass += ' right';
  }

  if (!props.me) {
    timestampClass += ' left';
  }

  if (props.narrow) {
    className += ' narrow';
  }

  if (props.multipleDown) {
    className += ' no-radius-bottom';
  }

  if (props.multipleUp) {
    className += ' no-radius-top';
  }

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Flex, {
    end: props.me,
    center: true
  }, /*#__PURE__*/React.createElement("div", {
    className: className,
    style: {
      display: 'flex'
    }
  }, props.flagged != null ? /*#__PURE__*/React.createElement("div", {
    className: "flag-badge"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "Flag"
  }), props.flagged) : /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: props.children
    }
  }), props["new"] && !props.me ? /*#__PURE__*/React.createElement("div", {
    className: "unread-badge"
  }) : null, props.actions != null && props.actions.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "action-menu"
  }, /*#__PURE__*/React.createElement(TooltipMenu, {
    trigger: "⋯",
    id: 'tooltip-message-' + props.messageId
  }, props.actions.map(function (action, index) {
    return /*#__PURE__*/React.createElement(TooltipMenu.Item, {
      onClick: action.onClick,
      key: 'action-' + index
    }, action.label);
  }))) : null)), /*#__PURE__*/React.createElement("div", {
    className: timestampClass
  }, props.sender != null ? props.sender + ' • ' : null, props.user != null ? props.user.firstName + ' ' + props.user.lastName + ' • ' : null, new DateTime(props.time).getTimeStampHours()));
};

export default Message;